import { makeAutoObservable } from "mobx";
import { IRmaPolicyRuleFee } from "../rma-types";
import { FEE_TYPE } from "../../../policies/policy-types";

class RmaPolicyRuleFeeStore {
    private _model: IRmaPolicyRuleFee = {} as IRmaPolicyRuleFee;

    constructor(model: IRmaPolicyRuleFee) {
        makeAutoObservable(this, {}, { autoBind: true});
        this._setModel(model);
    }

    private _setModel(model: IRmaPolicyRuleFee){
        this._model = ensureValidModel(model);
    }
    
    public get isCharged(): boolean { return this._model.is_charged; }
    public get feeType(): FEE_TYPE { return this._model.fee_type; }
}

export default RmaPolicyRuleFeeStore;

function ensureValidModel(model: IRmaPolicyRuleFee){
    const toBool = (v: undefined | any) => Boolean(v);
    return {...model,
        is_charged: toBool(model.is_charged),
    }
}